import { render, staticRenderFns } from "./List-dose.vue?vue&type=template&id=578e3280&"
import script from "./List-dose.vue?vue&type=script&lang=js&"
export * from "./List-dose.vue?vue&type=script&lang=js&"
import style0 from "./List-dose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports